"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Common_module_css_1 = __importDefault(require("./Common.module.css"));
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var material_1 = require("@mui/material");
var GenericList = function (props) {
    return (react_1.default.createElement("div", { className: Common_module_css_1.default["list-container"] },
        react_1.default.createElement(material_1.Table, null,
            react_1.default.createElement(material_1.TableHead, null,
                react_1.default.createElement(material_1.TableRow, { sx: { backgroundColor: "var(--secondary-color)" } }, props.columns.map(function (column, index) {
                    var _a;
                    return (react_1.default.createElement(material_1.TableCell, { key: index, sx: {
                            width: (_a = column.width) !== null && _a !== void 0 ? _a : "unset",
                            textAlign: index === props.columns.length - 1 ? "center" : "left",
                            color: "var(--info-color)"
                        } }, column.name));
                }))),
            react_1.default.createElement(material_1.TableBody, { "data-cy": "genericListBody" }, props.data.map(function (data) { return (react_1.default.createElement(material_1.TableRow, { key: data.id }, data.tooltipText ? (react_1.default.createElement(Tooltip_1.default, { className: "ns-font-family", title: react_1.default.createElement("span", { style: { margin: 0, padding: 0, whiteSpace: "pre-wrap" } }, data.tooltipText), placement: "top", arrow: true, PopperProps: {
                    sx: {
                        ".MuiTooltip-arrow": {
                            color: "var(--secondary-color)",
                        },
                        ".MuiTooltip-tooltip": {
                            backgroundColor: "var(--secondary-color)",
                            color: "var(--info-color)",
                            borderRadius: "7px",
                            padding: "12px"
                        },
                    },
                } },
                react_1.default.createElement("div", null, props.columns.map(function (column, colIndex) { return (react_1.default.createElement(material_1.TableCell, { key: colIndex, sx: { color: "var(--info-color)", textAlign: colIndex === props.columns.length - 1 ? "center" : "left" } }, data[column.dataIndex])); })))) : (react_1.default.createElement(react_1.default.Fragment, null, props.columns.map(function (column, colIndex) { return (react_1.default.createElement(material_1.TableCell, { key: colIndex, sx: { color: "var(--info-color)", textAlign: colIndex === props.columns.length - 1 ? "center" : "left" } }, data[column.dataIndex])); }))))); })))));
};
exports.default = GenericList;
